'use client';
import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkSkuCardMinProminent.module.css';

export function DevlinkSkuCardMinProminent({
  as: _Component = _Builtin.Link,
  imageShowImageSource = true,
  imageImageSource = 'https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/6603322a71125ba72e6481a4_hp-popular-sku-img-tv-md.jpg',
  imageShowImageSlot = false,
  imageImageSlot,
  title = 'Title',
  action = {},
}) {
  return (
    <_Component
      className={_utils.cx(_styles, 'ht-min-prominent-sku-card')}
      button={false}
      block="inline"
      options={{
        href: '#',
      }}
      {...action}
    >
      {imageShowImageSource ? (
        <_Builtin.Block className={_utils.cx(_styles, 'ht-min-prominent-sku-card-img')} tag="div">
          <_Builtin.Image
            className={_utils.cx(_styles, 'ht-inner-img', 'ht-fit')}
            loading="lazy"
            width="auto"
            height="auto"
            alt=""
            src={imageImageSource}
          />
        </_Builtin.Block>
      ) : null}
      {imageShowImageSlot ? (
        <_Builtin.Block className={_utils.cx(_styles, 'ht-min-prominent-sku-card-img')} tag="div">
          {imageImageSlot}
        </_Builtin.Block>
      ) : null}
      <_Builtin.Block className={_utils.cx(_styles, 'ht-min-prominent-sku-card-text')} tag="div">
        {title}
      </_Builtin.Block>
    </_Component>
  );
}
